export const METRICS_CARD_MIN_HEIGHT = '22rem';
